import { DiagramConnection } from './DiagramConnection';
import { DiagramComponentInstance } from './DiagramComponentInstance';

export type CurrentOSZoneType = 0 | 1 | 2.1 | 2.2 | 3 | 4;

export const CURRENT_OS_ZONE_ORDER: CurrentOSZoneType[] = [0, 1, 2.1, 2.2, 3, 4];

export const isCurrentOSZoneType = (value: unknown): value is CurrentOSZoneType =>
    CURRENT_OS_ZONE_ORDER.includes(value as CurrentOSZoneType);

export type Zone =
    | {
          id: string;
          type: 'control' | 'galvanic' | 'fault' | 'protection';
          initConnections?: DiagramConnection[];
          connections: DiagramConnection[];
          componentInstances: DiagramComponentInstance[];
          hash?: string;
      }
    | {
          id: string;
          type: 'currentOS';
          currentOSZoneType: CurrentOSZoneType;
          connections: DiagramConnection[];
          componentInstances: DiagramComponentInstance[];
          hash?: string;
      };

export type isZoneEndpoint = (componentInstance: DiagramComponentInstance, port: number | null) => boolean;

export type CurrentOSZones = {
    [type in CurrentOSZoneType]: Zone[];
};
